import React from "react";

export default function Subscriptions() {
  return (
    <div>
      <h1>Subscriptions Component</h1>
    </div>
  );
}
